import React from 'react';

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <p style={styles.text}>© {new Date().getFullYear()} YourCompanyName. All rights reserved.</p>
        <div style={styles.links}>
          <a href="/about" style={styles.link}>About</a>
          <a href="/contact" style={styles.link}>Contact</a>
          <a href="/privacy" style={styles.link}>Privacy Policy</a>
        </div>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    backgroundColor: '#222',
    color: '#fff',
    padding: '1rem 0',
    textAlign: 'center',
    marginTop: '2rem',
  },
  container: {
    maxWidth: '960px',
    margin: '0 auto',
  },
  text: {
    margin: '0 0 0.5rem 0',
  },
  links: {
    display: 'flex',
    justifyContent: 'center',
    gap: '1.5rem',
  },
  link: {
    color: '#aaa',
    textDecoration: 'none',
    fontSize: '0.9rem',
  },
};

export default Footer;
